import { BookingLink } from "../components/BookingLink.tsx";
import { Accented } from "../components/Accented.tsx";
import type { SiteContent } from "../lib/api.ts";

interface HeroProps {
  content: SiteContent;
}

/**
 * Defaults matter here: the hero is above the fold, so it must render something
 * sensible before /api/studio has answered rather than flashing empty headings.
 */
const FALLBACK = {
  "hero.eyebrow": "Facials · Finchampstead, near Wokingham",
  "hero.title": "Time, entirely *devoted to you.*",
  "hero.lede":
    "Bespoke Dermalogica facials with restorative facial massage in a private, one-to-one studio in Finchampstead, near Wokingham.",
  "hero.pointOne": "Professional Dermalogica skincare",
  "hero.pointTwo": "One therapist, consultation to aftercare",
};

export function Hero({ content }: HeroProps) {
  const text = (key: keyof typeof FALLBACK) => content[key] ?? FALLBACK[key];

  return (
    <section className="hero" id="top">
      {/*
        Decorative, so the alt is empty: the headline says what the page is.
        If the file is missing the olive ground shows through instead, and the
        layout is identical either way.
      */}
      <img
        className="hero__photo"
        src="/images/hero.jpg"
        alt=""
        fetchPriority="high"
        onError={(event) => {
          event.currentTarget.style.display = "none";
        }}
      />
      <div className="hero__veil" aria-hidden="true" />

      <div className="page hero__content">
        <p className="eyebrow hero__eyebrow">{text("hero.eyebrow")}</p>
        <h1 className="hero__title">
          <Accented text={text("hero.title")} />
        </h1>
        <p className="hero__lede">{text("hero.lede")}</p>
        <div className="hero__actions">
          <BookingLink className="btn btn--lg">
            Book an appointment
          </BookingLink>
          <a href="#treatments" className="btn btn--ghost btn--lg">
            Explore treatments
          </a>
        </div>
      </div>

      <ul className="page hero__points">
        <li>{text("hero.pointOne")}</li>
        <li>{text("hero.pointTwo")}</li>
      </ul>
    </section>
  );
}
